export default __webpack_public_path__ + "static/media/tickIcon.ab4b0e05.svg";